module.exports = __webpack_public_path__ + "img/integrations-wix.713e8be3.png";